
export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      datas: {
        alipay_id: '',
        alipay_name: '',
        bind_phone: ''
      },
      shows: false
    }
  },
  created() {

  },
  mounted: function () {
    this.getInfo()
  },
  methods: {
    toHome: function() {
      this.$router.push({ path: '/home' })
    },
    backPage: function() {
      window.history.go(-1)
    },
    getInfo: function () {
      this.apiGet('/h5/api/user/getUserInfo', '', res => {
        if (res.state) {
          this.datas.alipay_id = res.data.alipay_id || ''
          this.datas.alipay_name = res.data.alipay_name || ''
          this.datas.bind_phone = res.data.bind_phone || ''
        } else {
          this.$message('请输入支付宝账号')
        }
      })
    },
    checkPhone(phone) {
      if (!(/^1[123456789]\d{9}$/.test(phone))) {
        return false
      } else {
        return true
      }
    },
    save: function () {
      if (!this.datas.alipay_id) {
        this.$message('请输入支付宝账号')
        return
      }
      if (!this.datas.alipay_name) {
        this.$message('请输入支付宝姓名')
        return
      }
      if (!this.datas.bind_phone) {
        this.$message('为了您的账户安全，请绑定一个手机号码')
        return
      }
      let status = this.checkPhone(this.datas.bind_phone)
      if (!status) {
        this.$message('请输入正确手机号')
        return
      }
      this.apiGet('/h5/api/user/setAlipay', this.datas, res => {
        if (res.state) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message(res.msg)
        }
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/bind-ali/bind-ali.js